// API base URL for the frontend
// Use process.env.REACT_APP_API_URL if set, otherwise fallback to localhost
const API_URL = process.env.REACT_APP_API_URL || "http://192.168.1.19:8000";

export default API_URL;
